/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconComponents = createReactComponent("outline", "components", "IconComponents", [["path", { "d": "M3 12l3 3l3 -3l-3 -3z", "key": "svg-0" }], ["path", { "d": "M15 12l3 3l3 -3l-3 -3z", "key": "svg-1" }], ["path", { "d": "M9 6l3 3l3 -3l-3 -3z", "key": "svg-2" }], ["path", { "d": "M9 18l3 3l3 -3l-3 -3z", "key": "svg-3" }]]);

export { IconComponents as default };
//# sourceMappingURL=IconComponents.mjs.map
